module.exports = __webpack_public_path__ + "static/media/patch-check-fill.b5519a14.svg";